import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { enqueueSnackbar } from 'notistack';
import CompanyPage
  from '@fuww/library/src/Layouts/CompanyPage';
import SubscriptionFaq
  from '@fuww/library/src/SubscriptionFlowForm/Faq';
import messages from '../lib/messages.json';
import Head from '../components/Head';
import Layout from '../components/Layout';
import createCompanyBreadcrumbs
  from '../lib/createCompanyBreadcrumbs';
import withApollo from '../lib/apollo';
import SubscriptionTierComparison
  from '../components/SubscriptionTierComparison';
import subscriptionsFaq from '../lib/subscriptionsFaq';

const NewsSubscriptionPage = () => {
  const intl = useIntl();

  const handleCopyLink = () => {
    enqueueSnackbar(
      intl.formatMessage(messages.faqCopiedToClipboard),
      {
        variant: 'success',
        autoHideDuration: 3000,
        preventDuplicate: true,
      },
    );
  };

  const breadcrumbs = createCompanyBreadcrumbs({
    intl,
    crumbRoute: 'news-subscription',
    crumbLabel: intl.formatMessage(
      messages['newsSubscription.header'],
    ),
  });

  return (
    <>
      <Head
        title={intl.formatMessage(
          messages['newsSubscription.header'],
        )}
        description={intl.formatMessage(
          messages['newsSubscription.metaDescription'],
        )}
      />
      <CompanyPage
        breadcrumbs={breadcrumbs}
        description={intl.formatMessage(
          messages['newsSubscription.description'],
        )}
        title={intl.formatMessage(
          messages['newsSubscription.header'],
        )}
      >
        <SubscriptionTierComparison />
        <SubscriptionFaq
          faqData={subscriptionsFaq(intl)}
          faqHeaderLabel={intl.formatMessage(messages.faqHeader)}
          anchorId="faq"
          copyLinkAriaLabel={intl.formatMessage(
            messages.faqCopyLinkAriaLabel,
          )}
          onCopyLink={handleCopyLink}
        />
      </CompanyPage>
    </>
  );
};

NewsSubscriptionPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default withApollo(NewsSubscriptionPage);
